// Motore promozioni JS — mirror di backend server.py::compute_promotions.
// Usato in Cart per anteprima. Il server rimane fonte di verità (ricalcola a checkout).

export const isPromoActive = (p, now = new Date()) => {
  if (!p?.active) return false;
  if (p.starts_at && new Date(p.starts_at) > now) return false;
  if (p.ends_at && new Date(p.ends_at) < now) return false;
  return true;
};

const _norm = (s) => (s || "").toString().trim().toLowerCase();

const _matches = (promo, item) => {
  const b = _norm(promo.brand);
  const c = _norm(promo.category);
  if (b && b !== _norm(item.brand)) return false;
  if (c && c !== _norm(item.category)) return false;
  return true;
};

/**
 * Compute promotion effects for a client-side cart.
 * @param items array of {product_id, price, quantity, brand, category}
 * @param promos array of active promo docs from /promotions/active
 * @returns {instantDiscount, cashback, applied:[{promo_id,name,reward_type,amount,matching_qty,matching_sub}]}
 */
export const computePromotions = (items, promos) => {
  const applied = [];
  let instantDiscount = 0;
  let cashback = 0;
  const activeOnly = (promos || []).filter((p) => isPromoActive(p));
  for (const promo of activeOnly) {
    let matchingQty = 0;
    let matchingSub = 0;
    for (const it of items) {
      if (!_matches(promo, it)) continue;
      matchingQty += it.quantity;
      matchingSub += it.price * it.quantity;
    }
    const minQty = parseInt(promo.min_quantity) || 0;
    const minAmount = parseFloat(promo.min_amount) || 0;
    const triggered =
      (minQty && matchingQty >= minQty) ||
      (minAmount && matchingSub >= minAmount) ||
      (!minQty && !minAmount && matchingQty > 0);
    if (!triggered) continue;
    const value = parseFloat(promo.reward_value) || 0;
    let amount = 0;
    if (promo.reward_type === "percent_off") {
      amount = +(matchingSub * value / 100).toFixed(2);
      instantDiscount += amount;
    } else if (promo.reward_type === "fixed_off") {
      amount = Math.min(value, matchingSub);
      amount = +amount.toFixed(2);
      instantDiscount += amount;
    } else if (promo.reward_type === "cashback") {
      amount = +value.toFixed(2);
      cashback += amount;
    }
    if (amount > 0) {
      applied.push({
        promo_id: promo.promo_id,
        name: promo.name,
        reward_type: promo.reward_type,
        amount,
        matching_qty: matchingQty,
        matching_sub: +matchingSub.toFixed(2),
      });
    }
  }
  return {
    instantDiscount: +instantDiscount.toFixed(2),
    cashback: +cashback.toFixed(2),
    applied,
  };
};

export const REWARD_LABELS = {
  percent_off: (v) => `-${v}%`,
  fixed_off: (v) => `-€${v}`,
  cashback: (v) => `+€${v} wallet`,
};
